import styles from './ColumnsVisibility.module.css';

/**
 * ColumnsVisibility - Generic component to display grouped optGroup options
 * @template T - Type of the options in the columns arrays
 * @param {object} params
 * @param {import('react').ReactNode | null} [params.search] - Search bar element to render
 * @param {Array<{lib: string, options: Array<T>}>} params.options - Options grouped by label, passed back to children
 * @param {(label: string, options: T[]) => import('react').ReactNode} params.children - Render function receiving grouped options
 * @param {string} [params.messageNoOptions] - Message to display when there are no options
 * @returns {JSX.Element} ColumnsVisibility component
 */
function ColumnsVisibility({
  search = null, options, children, messageNoOptions = '',
}) {
  return (
    <div className={styles.container}>
      {search ? (
        <div className={styles.search}>
          {search}
        </div>
      ) : null}
      <div className={styles.content}>
        {options?.length ? options
          .map((option) => (
            children(
              option.lib,
              option.options,
            )
          )) : null}

        {!options?.length ? (
          <div className={styles['no-options']}>
            {messageNoOptions}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ColumnsVisibility;
